/**
 * Converts an ISO-like date string to a simple date format (YYYY-MM-DD).
 *
 * If the input is empty or undefined, an empty string is returned.
 *
 * @param value Date string, for example "2026-07-22T10:30:00Z" or "2026-07-22".
 * @returns Date-only string in YYYY-MM-DD format, or an empty string.
 *
 * @example
 * toSimpleDate('2026-07-22T10:30:00Z') // '2026-07-22'
 */
export const toSimpleDate = (value?: string | null) => {
  if (!value) return '';

  return value.split('T')[0];
};
